  
    <cradua-contractor
        [seismiccontractors]="seismiccontractors$ | async"
        (seismiccontractor)="onSubmitSeismicContractor($event)"
        (searchevent)="searchContractors($event)"
        (deleteSeismicContractorEvent)="onDeleteSeismicContractor($event)"
        *ngIf="(isLoadingSeismicContractor$ | async ) === false"
        >
  </cradua-contractor>
  
    <mrsoftapps-epims-reference-spinner
    
    *ngIf="(isLoadingSeismicContractor$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  